import * as React from 'react';
export var ToggleTemplate = function ToggleTemplate(_ref) {
  var _ref$firstIndex = _ref.firstIndex,
      firstIndex = _ref$firstIndex === void 0 ? 0 : _ref$firstIndex,
      _ref$lastIndex = _ref.lastIndex,
      lastIndex = _ref$lastIndex === void 0 ? 0 : _ref$lastIndex,
      _ref$itemCount = _ref.itemCount,
      itemCount = _ref$itemCount === void 0 ? 0 : _ref$itemCount,
      _ref$itemsTitle = _ref.itemsTitle,
      itemsTitle = _ref$itemsTitle === void 0 ? 'items' : _ref$itemsTitle;
  return React.createElement(React.Fragment, null, React.createElement("b", null, firstIndex, " - ", lastIndex), ' ', "of ", React.createElement("b", null, itemCount), " ", itemsTitle);
};